import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Equipment Name',
    field: 'equipmentName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Note',
    field: 'notes',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service History',
    field: 'history',
    filter: 'text',
  },
  {
    title: 'Brand',
    field: 'brand',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Model Number',
    field: 'modelNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Serial Number',
    field: 'serialNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Warranty Period',
    field: 'warantyPeriod',
    filter: 'numeric',
    searchable: true,
  },
  {
    title: 'Purchased On',
    field: 'purchasedOn',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'boolean',
    searchable: true,
  },
];
